// src/hooks/useQuery.ts
import { fetcher } from "@repo/core-api";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
var useQuery = (path, { condition, ...config } = {}) => {
  const shouldFetch = typeof condition === "boolean" ? condition : true;
  return useSWR(shouldFetch ? path : void 0, fetcher, config);
};
var useImmutableQuery = (path, { condition, ...config } = {}) => {
  const shouldFetch = typeof condition === "boolean" ? condition : true;
  return useSWRImmutable(shouldFetch ? path : void 0, fetcher, config);
};
export {
  useImmutableQuery,
  useQuery
};
